export default {
    path:'/',
    preload:false,
    middlewares: []
  }
